import type { FC, FormEvent } from 'react';

interface CancelStudyProps {
  closeModal: () => void;
  onClick: () => void;
  testId?: string;
}

/**
 * Confirmation modal for cancelling a study.
 */
const CancelStudy: FC<CancelStudyProps> = ({ closeModal, onClick, testId = 'cancel-study' }) => {
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onClick();
  };

  return (
    <form onSubmit={handleSubmit} className="ui__narrow-modal" data-test-component="CancelStudy" data-testid={testId}>
      <div className="pb3 tc">
        <h3 className="normal f4 pb2">Are you sure you would like to cancel this study?</h3>
        <div className="f6 pb2">
          <p className="mt2 mb3">If a study is cancelled it will become read-only and has limited functionality.</p>
          <p>Cancelled studies can be resumed later in its settings page.</p>
        </div>
      </div>
      <div>
        <button type="submit" className="button w-100" data-testid="cancel-study__submit">
          Cancel study
        </button>
        <button
          type="button"
          className="button plain db w-100 mt2"
          onClick={closeModal}
          data-testid="cancel-study__dismiss"
        >
          Dismiss
        </button>
      </div>
    </form>
  );
};

export default CancelStudy;
